import styled from 'styled-components';

import { Card } from '@xing-com/card';
import type { JobSalary } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { isValidSalaryEstimate } from '@xing-com/crate-jobs-helpers';
import { InViewTracking } from '@xing-com/crate-jobs-tracking';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

import { SalaryEstimation } from './salary-estimation';

const SalaryContainer = styled(Card)`
  width: 100%;

  /* remove all card styles on small screen */
  @media ${mediaSmallOrTiny} {
    background-color: transparent;
    border: none;
    padding: 0;
  }
`;

type Props = {
  jobGlobalId: string;
  modulePosition: number;
  salary?: JobSalary | null;
};

export const SalaryModule: React.FC<Props> = ({
  salary,
  jobGlobalId,
  modulePosition,
}) => {
  const { isLoggedIn } = useLoginState();
  const nwtTrackingOptions = {
    eventSchema: 'extended',
    itemUrn: jobGlobalId,
    page: 'jobs/detail',
    moduleTitle: 'salary_forecast',
    modulePosition: modulePosition,
  } as const;

  return isValidSalaryEstimate(salary) ? (
    <InViewTracking
      nwtTrackingOptions={{ ...nwtTrackingOptions, event: 'entered_viewport' }}
      skip={isLoggedIn}
    >
      <SalaryContainer data-testid="job-details-salary-card">
        <SalaryEstimation salary={salary} />
      </SalaryContainer>
    </InViewTracking>
  ) : null;
};
